import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles'
import { Grid, IconButton } from '@material-ui/core'
import { DataGrid } from '@material-ui/data-grid'
import ViewIcon from '@material-ui/icons/Visibility'
import DeleteIcon from '@material-ui/icons/Delete'

import api from '../../services/api';
import { loadForms, formDeleted } from '../../redux/ducks/formularios'

const cellButtonStyles = theme => ({
  marginLeft: theme.spacing.unit,
  padding: 5,
  borderRadius: 3
})

const useStyles = makeStyles(theme => ({
  root: {
    '& .header-cell': {
      color: 'white',
      fontWeight: 'bold'
    },
    '& .cell': {
      color: 'white'
    },
    '& .controls-row': {
      color: 'white',
      padding: 0,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    '& .MuiDataGrid-footer, & .MuiTablePagination-root, & .MuiIconButton-root': {
      color: 'white'
    },
    '& .MuiIconButton-root.Mui-disabled': {
      color: '#888'
    }
  },
  viewButton: {
    backgroundColor: '#c358d4',
    '&:hover': {
      backgroundColor: '#a338c4',
    },
    ...cellButtonStyles(theme)
  },
  deleteButton: {
    backgroundColor: '#e43863',
    '&:hover': {
      backgroundColor: '#d32854',
    },
  marginRight: theme.spacing(2.5),
  ...cellButtonStyles(theme)
  }
}))

export default function Dashboard() {
  const classes = useStyles()
  const dispatch = useDispatch();
  const [listaPacientes, setListaPacientes] = useState([]);
  const [dataRows, setDataRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageAtual, setPageAtual] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const dataColumns = [
    {
      field: 'id',
      headerName: ' ',
      headerClassName: 'controls-header',
      cellClassName: 'controls-row',
      renderCell: params => (
        <strong>
          <Link to={`formulario/${params.value}`}>
            <IconButton 
              className={classes.viewButton}
              edge='start'
              color='inherit'
              aria-label='visualizar'
            >
              <ViewIcon />
            </IconButton>
          </Link>
          <IconButton 
            className={classes.deleteButton}
            edge='start'
            color='inherit'
            aria-label='visualizar'
            onClick={() => deleteForm(params.value)}
          >
            <DeleteIcon />
          </IconButton>
        </strong>
      ),
      width: 120
    },
    { 
      field: 'nome', 
      headerName: 'Nome do Paciente', 
      headerClassName: 'header-cell',
      cellClassName: 'cell',
      width: 180
    },
    { 
      field: 'criado', 
      headerName: 'Criado em', 
      headerClassName: 'header-cell',
      cellClassName: 'cell',
      width: 180
    },
  ]

  async function deleteForm (formId) {
    const res = await api.delete(`/formulario/${formId}`)
    if (res.status == '200') onFormDeleted(formId)
  }

  const onFormDeleted = formId => {
    dispatch(formDeleted(formId))
    setListaPacientes(listaPacientes.filter(p => p.id !== formId))
    setDataRows(dataRows.filter(d => d.id !== formId))
  }

  const formatDate = d => {
    let [date, time] = d.split(' ')
    date = date.split('-').reverse().join('/')
    time = time.split(':').slice(0,2).join(':')
    return date+' às '+time
  }

  useEffect( () => {
    setLoading(true)
    async function CallPaciente(finish) {
      const { data } = await api.get(`/lista-formularios?page=${pageAtual}`);
      setLastPage(data.lastPage);
      dispatch(loadForms(data.data))
      setDataRows(data.data.map(d => ({
        id: d.id,
        nome: d.nomepaciente,
        criado: formatDate(d.created_at)
      })))
      finish()
    }
    CallPaciente(() => setLoading(false));
  }, [pageAtual]);


return (
  <>
    <Grid item xs={1} md={3} /> 
    <Grid item xs={10} md={6}>
      <div style={{ height: '80vh', maxWidth: '880px', margin: 'auto' }}>
        <DataGrid
          className={classes.root} 
          rows={dataRows} 
          columns={dataColumns}
          loading={loading}
          rowsPerPageOptions={[10, 50, 100]}
        />
      </div>
    </Grid>
    <Grid item xs={1} md={3}/>
  </> 
  );
}
